const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOAD_LABELS':
      return {
        ...state,
        ...action.labels,
      };
    case 'CLEAR_ENROLLMENT_FORM':
      return initialState;
    default:
      return state;
  }
}
